<template>
    <div class="container">
        <div class="card mb-1">
            <ul class="list-group list-group-flush">
                <li class="list-group-item" v-for="item in list" :key="item.id">
                    <tech-row :item="item"></tech-row>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    import TechRow from 'pages/invites/techLevel/components/Row'
    import {mapGetters} from 'vuex'

    export default {
        props: {
            list: Array
        },
        components: {
            TechRow
        },
        methods: {
            toTechChild (code, name, level) {
                this.$router.push({name:'TechChild', params:{
                    code: code,
                    name: name,
                    level: level
                }})
            }
        }
    }
</script>

<style lang="stylus" scoped>
    @import '~stylus/base/mixins.styl'
    .opacity0
        opacity: 0
    .wrapper-name
        display:flex
        white-space: nowrap
        .name
            ellipsis()
</style>
